// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__27Ylv","actionsCol":"EnrolledClinics_actionsCol__V5Lg0"};